import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { useParams } from 'react-router-dom'

import { Spinner } from '../../../Components'
import { formatEuro3Decimals } from '../../../Services/Functions'
import { useCQuery } from '../../../Services/QueryCache'
import { cap } from '../../../State'
import { translations } from '../../../translations'

const language = cap.language.state || 'IT'
const t = translations[language]

export const Pricing = () => {
  const { processId } = useParams()
  const { data: totalTokens = [], isSuccess } = useCQuery(['pricingPerProcess', processId])

  if (!isSuccess) return <Spinner />
  return (
    <div className="process-stats-pricing">
      <DataTable value={totalTokens} className="TableSignatures process-stats-pricing__table">
        <Column field="provider" header="Provider" />
        <Column field="tokenCount" header={t.pfTokenRichieste} />
        <Column field="price" header={t.pfCosto} body={({ price }) => formatEuro3Decimals(price)} />
        <Column field="total" header={t.totale} body={({ total }) => formatEuro3Decimals(total)} />
      </DataTable>
    </div>
  )
}
